// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =====================================================================
   Imergey Admin — Global Components & States
   Loaded after chrome.css. Restyles antd v4 + bootstrap primitives via
   overrides only (no markup changes).
   ===================================================================== */

/* ============================== Cards ============================== */
.ant-card,
.ant-card.criclebox {
  border-radius: var(--r-lg) !important;
  border: 1px solid var(--border) !important;
  box-shadow: var(--shadow-sm) !important;
  background: var(--bg-surface);
  transition: box-shadow var(--dur-base) var(--ease-out);
}
.ant-card.criclebox:hover {
  box-shadow: var(--shadow-md) !important;
}
.ant-card-head {
  border-bottom: 1px solid var(--border) !important;
  min-height: 62px;
  padding: 0 var(--space-6) !important;
}
.ant-card-head-title {
  font-family: var(--font-display) !important;
  font-weight: var(--fw-bold) !important;
  font-size: var(--fs-lg) !important;
  color: var(--text-primary) !important;
  padding: 18px 0 !important;
}
.ant-card-body {
  padding: var(--space-6);
}

/* ============================== Buttons ============================== */
.ant-btn {
  border-radius: var(--r-md) !important;
  font-weight: var(--fw-semibold);
  box-shadow: none;
  transition: transform var(--dur-fast) var(--ease-out),
    box-shadow var(--dur-fast) var(--ease-out), background var(--dur-fast) var(--ease-out),
    border-color var(--dur-fast) var(--ease-out), color var(--dur-fast) var(--ease-out) !important;
}

.ant-btn-primary,
button.ant-btn.ant-btn-primary {
  background: var(--brand-gradient) !important;
  border: none !important;
  color: #fff !important;
  box-shadow: var(--shadow-brand);
}
.ant-btn-primary:hover,
.ant-btn-primary:focus,
button.ant-btn.ant-btn-primary:hover {
  background: var(--brand-gradient-hover) !important;
  color: #fff !important;
  transform: translateY(-1px);
  box-shadow: 0 14px 30px -6px rgba(7, 29, 49, 0.5);
}
.ant-btn-primary:active {
  transform: translateY(0);
}

.ant-btn-default {
  background: var(--bg-surface);
  border: 1px solid var(--border-strong) !important;
  color: var(--text-secondary) !important;
}
.ant-btn-default:hover,
.ant-btn-default:focus {
  border-color: var(--brand-400) !important;
  color: var(--brand-600) !important;
  transform: translateY(-1px);
}

.ant-btn-dangerous {
  color: var(--error) !important;
  border-color: var(--error) !important;
}
.ant-btn-dangerous.ant-btn-primary {
  background: var(--error) !important;
  color: #fff !important;
}

.ant-btn[disabled],
.ant-btn[disabled]:hover {
  opacity: 0.55;
  transform: none !important;
  box-shadow: none !important;
  background: var(--n-100) !important;
  color: var(--text-muted) !important;
  border-color: var(--border) !important;
}
.ant-btn-primary[disabled],
.ant-btn-primary[disabled]:hover {
  background: var(--n-200) !important;
}

/* Status-indicator buttons (e.g. "Original Contract Exists", "Manual
   Onboarding Active") are disabled to prevent re-clicking, but they still
   need to read as "on"/branded rather than washed-out grey like a truly
   inert control. */
.ant-btn.gfx-btn-active[disabled],
.ant-btn.gfx-btn-active[disabled]:hover {
  opacity: 1;
  background: var(--brand-gradient) !important;
  color: #fff !important;
  border-color: transparent !important;
  cursor: default;
}
.ant-btn.gfx-btn-active.gfx-btn-success[disabled],
.ant-btn.gfx-btn-active.gfx-btn-success[disabled]:hover {
  background: #27ae60 !important;
  border-color: #27ae60 !important;
}
.ant-btn.gfx-btn-active.gfx-btn-warning[disabled],
.ant-btn.gfx-btn-active.gfx-btn-warning[disabled]:hover {
  background: #f39c12 !important;
  border-color: #f39c12 !important;
}

.btn-primary {
  background: var(--brand-gradient) !important;
  border: none !important;
  border-radius: var(--r-md) !important;
}
.btn-primary:hover {
  background: var(--brand-gradient-hover) !important;
}

/* ============================== Inputs / Forms ============================== */
.ant-input,
.ant-input-affix-wrapper,
.ant-input-number,
.ant-picker {
  border-radius: var(--r-md) !important;
  border: 1px solid var(--border-strong) !important;
  color: var(--text-primary);
  font-size: var(--fs-base) !important;
  transition: border-color var(--dur-fast) var(--ease-out), box-shadow var(--dur-fast) var(--ease-out) !important;
}
.ant-input::placeholder {
  color: var(--text-muted);
}
.ant-input:hover,
.ant-input-affix-wrapper:hover,
.ant-picker:hover {
  border-color: var(--brand-300) !important;
}
.ant-input:focus,
.ant-input-focused,
.ant-input-affix-wrapper:focus,
.ant-input-affix-wrapper-focused,
.ant-picker-focused {
  border-color: var(--brand-500) !important;
  box-shadow: 0 0 0 3px var(--ring) !important;
}

.ant-select:not(.ant-select-disabled) .ant-select-selector {
  border-radius: var(--r-md) !important;
  border-color: var(--border-strong) !important;
  transition: border-color var(--dur-fast) var(--ease-out), box-shadow var(--dur-fast) var(--ease-out) !important;
}
.ant-select:not(.ant-select-disabled):hover .ant-select-selector {
  border-color: var(--brand-300) !important;
}
.ant-select-focused:not(.ant-select-disabled) .ant-select-selector {
  border-color: var(--brand-500) !important;
  box-shadow: 0 0 0 3px var(--ring) !important;
}

.ant-form-item-label > label {
  font-weight: var(--fw-semibold);
  color: var(--text-primary);
  font-size: var(--fs-sm);
}
.ant-form-item-explain-error {
  color: var(--error);
  font-size: var(--fs-xs);
  margin-top: 4px;
}
.ant-form-item-has-error .ant-input,
.ant-form-item-has-error .ant-input-affix-wrapper,
.ant-form-item-has-error .ant-select .ant-select-selector {
  border-color: var(--error) !important;
}
.ant-form-item-has-success.ant-form-item-has-feedback .ant-input {
  border-color: var(--success) !important;
}

/* ============================== Tables ============================== */
.ant-table {
  background: transparent;
  border-radius: var(--r-md);
}
.ant-table-thead > tr > th {
  background: var(--bg-subtle) !important;
  color: var(--text-muted) !important;
  font-weight: var(--fw-semibold) !important;
  font-size: var(--fs-xs) !important;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  border-bottom: 1px solid var(--border) !important;
}
.ant-table-tbody > tr > td {
  border-bottom: 1px solid var(--border);
  color: var(--text-secondary);
}
.ant-table-tbody > tr {
  transition: background var(--dur-fast) var(--ease-out);
}
.ant-table-tbody > tr:hover > td,
.ant-table-tbody > tr.ant-table-row:hover > td {
  background: var(--bg-hover) !important;
}

/* ============================== Pagination ============================== */
.ant-pagination-item {
  border-radius: var(--r-sm) !important;
  border-color: var(--border) !important;
  transition: all var(--dur-fast) var(--ease-out);
}
.ant-pagination-item a {
  color: var(--text-secondary);
}
.ant-pagination-item:hover {
  border-color: var(--brand-400) !important;
}
.ant-pagination-item:hover a {
  color: var(--brand-600);
}
.ant-pagination-item-active {
  border-color: var(--brand-500) !important;
  background: var(--brand-50) !important;
}
.ant-pagination-item-active a {
  color: var(--brand-700) !important;
  font-weight: var(--fw-semibold);
}
.ant-pagination-prev .ant-pagination-item-link,
.ant-pagination-next .ant-pagination-item-link {
  border-radius: var(--r-sm) !important;
  border-color: var(--border) !important;
}

/* ============================== Modals / Drawers ============================== */
.ant-modal-mask {
  background: rgba(15, 23, 42, 0.5) !important;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}
.ant-modal-content {
  border-radius: var(--r-xl) !important;
  box-shadow: var(--shadow-xl) !important;
  overflow: hidden;
}
.ant-modal-title,
.modal_title_cls {
  font-family: var(--font-display) !important;
  font-weight: var(--fw-bold) !important;
  color: var(--text-primary) !important;
}
.ant-modal-footer .ant-btn,
.ant-modal.tab_modal .ant-modal-footer .ant-btn {
  border-radius: var(--r-md) !important;
}
.ant-drawer-content {
  border-top-left-radius: var(--r-lg);
  border-bottom-left-radius: var(--r-lg);
}
.ant-drawer-header {
  border-bottom: 1px solid var(--border);
}
.ant-drawer-title {
  font-family: var(--font-display);
  font-weight: var(--fw-bold);
  color: var(--text-primary);
}

/* ============================== Dropdowns / Menus ============================== */
.ant-dropdown-menu {
  border-radius: var(--r-md) !important;
  box-shadow: var(--shadow-lg) !important;
  padding: 6px !important;
  border: 1px solid var(--border);
}
.ant-dropdown-menu-item {
  border-radius: var(--r-sm) !important;
  font-weight: var(--fw-medium);
  transition: background var(--dur-fast) var(--ease-out);
}
.ant-dropdown-menu-item:hover {
  background: var(--bg-hover) !important;
}

/* ============================== Accents ============================== */
.ant-switch-checked {
  background: var(--brand-600) !important;
}
.ant-checkbox-checked .ant-checkbox-inner {
  background: var(--brand-600) !important;
  border-color: var(--brand-600) !important;
}
.ant-checkbox-wrapper:hover .ant-checkbox-inner,
.ant-checkbox:hover .ant-checkbox-inner {
  border-color: var(--brand-500) !important;
}
.ant-radio-checked .ant-radio-inner {
  border-color: var(--brand-600) !important;
}
.ant-radio-inner::after {
  background-color: var(--brand-600) !important;
}
.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: var(--brand-600) !important;
  font-weight: var(--fw-semibold);
}
.ant-tabs-ink-bar {
  background: var(--brand-gradient) !important;
}
.ant-spin-dot-item {
  background-color: var(--brand-600) !important;
}

/* ============================== Empty / states ============================== */
.ant-empty-description {
  color: var(--text-muted);
  font-size: var(--fs-sm);
}

/* ============================== Tables: mobile density ============================== */
@media (max-width: 576px) {
  .ant-table-tbody > tr > td,
  .ant-table-thead > tr > th {
    padding: 10px 12px !important;
    font-size: var(--fs-xs) !important;
  }
}

/* ============================== Badges / Tags ============================== */
.ant-tag {
  border-radius: var(--r-full);
  font-weight: var(--fw-medium);
  border: none;
  padding: 2px 12px;
}
.ant-badge-count {
  box-shadow: 0 0 0 2px var(--bg-surface);
  font-weight: var(--fw-semibold);
}

/* ============================== Graphics: file/version rows ============================== */
.gfx-file-row.ant-list-item {
  border-radius: var(--r-lg);
  transition: background var(--dur-base) var(--ease-out);
  padding: 12px 10px !important;
}
.gfx-file-row.ant-list-item:hover {
  background: var(--bg-subtle, #F8FAFC);
}
.gfx-file-name {
  font-weight: var(--fw-semibold);
  color: var(--text-primary, #0F172A);
}
.gfx-file-meta {
  font-size: 12px;
  color: var(--text-muted, #94A3B8);
  margin-top: 2px;
}
.gfx-file-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.gfx-file-view-btn,
.gfx-file-download-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  font-weight: 600;
  padding: 6px 14px;
  border-radius: var(--r-full);
  white-space: nowrap;
  transition: background 0.15s ease, color 0.15s ease;
}
.gfx-file-view-btn {
  color: #0F9E9B;
  border: 1px solid #9FE3E1;
  background: #ffffff;
}
.gfx-file-view-btn:hover {
  background: #0F9E9B;
  color: #ffffff;
}
.gfx-file-download-btn {
  color: var(--brand-500, #3B6B94);
  border: 1px solid var(--brand-200, #A8C5DA);
  background: #ffffff;
}
.gfx-file-download-btn:hover {
  background: var(--brand-500, #3B6B94);
  color: #ffffff;
}
.gfx-file-icon-btn.ant-btn {
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
  padding: 0 !important;
  border-radius: var(--r-full) !important;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border, #E7E9F2) !important;
  color: var(--text-secondary, #475569) !important;
  background: #ffffff !important;
}
.gfx-file-icon-btn.ant-btn:hover {
  border-color: var(--brand-300, #7CA7C2) !important;
  color: var(--brand-500, #3B6B94) !important;
}
.gfx-file-icon-btn--danger.ant-btn:hover {
  border-color: #ffccc7 !important;
  background: #fff1f0 !important;
  color: #cf1322 !important;
}
.gfx-note-editor {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 6px;
}
.gfx-note-editor .ant-input {
  border-radius: var(--r-md, 8px);
}

/* ==============================================================
   Graphics Request Detail -- ported from graphics-Imergey's modern
   hero-header layout, so Brand/Admin's detail page reads the same
   as the Graphics Team member's own view of the same request.
   ============================================================== */
.gfx-req-hero {
  border-radius: var(--r-xl, 20px);
  padding: 22px 26px;
  margin-bottom: 20px;
  background: var(--brand-gradient);
  box-shadow: var(--shadow-brand);
}
.gfx-req-hero-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
}
.gfx-req-hero-eyebrow {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(255,255,255,0.65);
  margin-bottom: 4px;
}
.gfx-req-hero-title {
  margin: 0;
  color: #ffffff;
  font-size: 21px;
  font-weight: 700;
  letter-spacing: -0.2px;
}
.gfx-req-hero-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.gfx-hero-pill {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: 34px;
  padding: 0 16px;
  border-radius: 9999px;
  background: rgba(255, 255, 255, 0.10);
  border: 1px solid rgba(255, 255, 255, 0.18);
  color: #ffffff;
  font-size: 12.5px;
  font-weight: 600;
  white-space: nowrap;
}
.gfx-hero-pill--status {
  background: rgba(108, 229, 232, 0.14);
  border-color: rgba(108, 229, 232, 0.38);
  color: #A9F0F2;
}
.gfx-hero-pill .gfx-priority-dot { width: 8px; height: 8px; }
.gfx-hero-action-btn.ant-btn {
  height: 34px !important;
  border-radius: 9999px !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  background: rgba(255, 255, 255, 0.10) !important;
  color: #ffffff !important;
  padding: 0 16px !important;
  font-weight: 600 !important;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.gfx-hero-action-btn.ant-btn:hover {
  background: rgba(255, 255, 255, 0.18) !important;
  color: #ffffff !important;
  border-color: rgba(255, 255, 255, 0.4) !important;
}
.gfx-hero-action-btn.gfx-hero-action-btn--danger.ant-btn {
  background: rgba(245, 34, 45, 0.16) !important;
  border-color: rgba(245, 34, 45, 0.35) !important;
  color: #FFD8D6 !important;
}
.gfx-hero-action-btn.gfx-hero-action-btn--danger.ant-btn:hover {
  background: rgba(245, 34, 45, 0.28) !important;
}

/* Same pill shape + icon/text alignment as .gfx-hero-action-btn above, but
   for a plain white/light background (the blog-write version editor drawer)
   — .gfx-hero-action-btn's own colors (translucent white bg, white text)
   are only visible on its dark hero-banner background and would be
   invisible-on-white here, so this keeps antd's own primary/danger
   coloring and only borrows the shape/alignment fix. */
.gfx-drawer-action-btn.ant-btn {
  height: 34px !important;
  border-radius: 9999px !important;
  padding: 0 16px !important;
  font-weight: 600 !important;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  /* Space between separate buttons in the drawer relies on antd's own
     Space \`gap\` (flex column-gap on an inline-flex container) — that
     doesn't render reliably everywhere, so add an explicit fallback
     margin directly on the button too. The trailing margin on the last
     button is harmless (just a bit of empty space before the drawer's
     own edge). */
  margin-right: 12px;
}

.gfx-priority-dot { border-radius: 50%; display: inline-block; }
.gfx-priority-dot.priority-urgent { background: #F5222D; }
.gfx-priority-dot.priority-high   { background: #FA8C16; }
.gfx-priority-dot.priority-medium { background: #3B6B94; }
.gfx-priority-dot.priority-low    { background: #94A3B8; }

/* Meta tiles */
.gfx-meta-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
}
.gfx-meta-tile {
  background: var(--bg-subtle, #F8FAFC);
  border: 1px solid var(--border, #E7E9F2);
  border-radius: 12px;
  padding: 14px 16px;
  min-width: 0;
}
.gfx-meta-label {
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--text-muted, #94A3B8);
  margin-bottom: 5px;
}
.gfx-meta-value {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary, #0F172A);
  overflow-wrap: break-word;
}
.gfx-meta-tile--alert { background: #FEF2F2; border-color: #FECACA; }
.gfx-meta-tile--alert .gfx-meta-value { color: #B91C1C; }

/* Brief panels */
.gfx-brief-stack {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
}
.gfx-brief-panel {
  background: #ffffff;
  border: 1px solid var(--border, #E7E9F2);
  border-left: 3px solid var(--brand-500, #3B6B94);
  border-radius: 10px;
  padding: 13px 16px;
}
.gfx-brief-label {
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--brand-500, #3B6B94);
  margin-bottom: 6px;
}
.gfx-brief-text {
  font-size: 13.5px;
  color: var(--text-secondary, #475569);
  line-height: 1.65;
  margin: 0;
  white-space: pre-wrap;
}
/* THE actual cause of the "still not fixed" line-spacing bug — found it.
   white-space: pre-wrap above was written for this class's ORIGINAL use
   (rendering a plain-text field, where it's needed to turn the user's
   typed line breaks into visible ones, since a plain string has no <p>/
   <br> tags of its own to do that). It's an INHERITED property, so once
   this same class started also being used to dangerouslySetInnerHTML real
   rich HTML (the outline/header/subheader fields), pre-wrap started
   applying to that markup too — and draftjs-to-html's own output has
   literal newline characters between block tags (for readability), which
   pre-wrap then renders as REAL, VISIBLE extra line breaks, stacking on
   top of each <p>'s own margin. That's what produced gaps of inconsistent,
   oversized height between lines that no amount of margin tuning alone
   could fix (previous attempt only touched margin, hence "still not
   fixed"). Fixed by giving the rich-HTML case its own modifier class
   (.gfx-brief-text-rich, added in JSX alongside .gfx-brief-text) that
   turns white-space back to normal — collapsing those stray newlines the
   way HTML always does by default — while leaving plain .gfx-brief-text
   alone so the legacy flat-string fields (which are NOT HTML, must never
   get dangerouslySetInnerHTML) keep their pre-wrap behavior intact. */
.gfx-brief-text.gfx-brief-text-rich {
  white-space: normal;
}
/* Round 2 fix — forcing every <p> to a flat "margin: 0 0 8px" (previous
   attempt) was itself wrong, not just the pre-wrap issue above: it made
   every paragraph gap the SAME 8px regardless of how many blank lines the
   writer actually typed in the editor. draftjs-to-html emits one <p> per
   editor line, and a blank line the writer typed (pressed Enter twice)
   comes out as its own empty <p>&nbsp;</p> block — so 1 blank line should
   read as 1 blank-line's worth of gap, 2 blank lines as 2, etc., exactly
   like it looked while writing. Flattening every <p> margin to 8px erased
   that distinction (any run of blank lines collapsed to the same gap as a
   single line break) — that's the "format is not same as what I typed"
   complaint. Fix: margin 0 on every <p> so it's purely line-height driven,
   the same way the compose editor itself renders lines — an empty <p> then
   naturally reproduces one blank editor line's height, and N blank lines
   in a row reproduce N of them, matching the source 1:1. */
.gfx-brief-text-rich p {
  margin: 0;
}
/* Round 3 fix — the margin:0 approach above was the right idea but still
   didn't work, because draftjs-to-html doesn't serialize a real blank line
   as "<p>&nbsp;</p>" (what I assumed and tested against) — it serializes it
   as a completely bare "<p></p>" (confirmed by the comment on
   serializeEditorHtml in NormalEditor.js, which deliberately leaves it
   untouched for this exact reason). A block element with truly NO content —
   not even a space — gets NO line box in every browser, so it renders at
   zero height regardless of line-height/margin. That's why blank lines kept
   disappearing even after the spacing model was fixed. Giving empty <p>s
   generated content (a non-breaking space) forces a real line box the same
   height as any other line, so a blank editor line now actually reproduces
   as one blank line here, and N in a row as N. */
.gfx-brief-text-rich p:empty::before {
  content: "\\00a0";
}
.gfx-brief-text-rich ul,
.gfx-brief-text-rich ol {
  margin: 0;
  padding-left: 20px;
}
.gfx-brief-text-rich li {
  margin-bottom: 2px;
}
/* linkifyHtml (BlogDescriptionModal.js) wraps bare URLs typed into an
   outline field (the editor's own toolbar has no link button) in a real
   <a> at display time — styled so it actually reads as a clickable link
   instead of the same flat body-text color everything else here uses. */
.gfx-brief-text-rich a {
  color: var(--brand-500, #3B6B94);
  text-decoration: underline;
  word-break: break-all;
}

/* Matches BlogWriteService.getVersionHtml's docx alignment-preservation
   transform (backend-Imergey) — paragraphs tagged with these classes carry
   real alignment from the source .docx (mammoth otherwise drops it by
   default). An image sitting alone in its own aligned paragraph is centered
   for free here too, since it just inherits text-align from its <p>. */
.gfx-brief-text-rich .align-left { text-align: left; }
.gfx-brief-text-rich .align-center { text-align: center; }
.gfx-brief-text-rich .align-right { text-align: right; }
.gfx-brief-text-rich .align-justify { text-align: justify; }

/* Outline "Body" block (headers/sub-headers) — these classes existed in the
   JSX (BlogWriteRequestDetail.js) but had NO CSS defined for them anywhere,
   so header/subheader titles rendered as plain unstyled text indistinguishable
   from body copy, and separate blocks (a header's own content, then its
   subheaders) sat flush against each other with zero gap — since the
   margin:0 fix above makes each .gfx-brief-text-rich block internally
   line-height-only, there was nothing left to separate one block from the
   next. Titles get real heading weight/size; each header/subheader gets a
   top margin so distinct blocks read as visually separate sections, the
   same way they're visually separate while writing them in the outline
   builder. */
.blog-desc-outline-header {
  margin-top: 16px;
}
.blog-desc-outline-header:first-child {
  margin-top: 0;
}
.blog-desc-outline-header-title {
  font-size: 14.5px;
  font-weight: 700;
  color: var(--text-primary, #0F172A);
  margin-bottom: 4px;
}
.blog-desc-outline-subheader {
  margin-top: 10px;
  padding-left: 14px;
  border-left: 2px solid var(--border, #E7E9F2);
}
.blog-desc-outline-subheader-title {
  font-size: 13.5px;
  font-weight: 600;
  color: var(--text-primary, #0F172A);
  margin-bottom: 4px;
}

/* Reference file chips */
.gfx-ref-files { margin-top: 16px; }
.gfx-ref-chips { display: flex; flex-wrap: wrap; gap: 8px; }
.gfx-ref-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  max-width: 320px;
  padding: 8px 14px;
  border-radius: 9999px;
  background: var(--brand-50, #EAF1F6);
  border: 1px solid var(--brand-100, #D2E2EC);
  color: var(--brand-700, #1D3C56);
  font-size: 12.5px;
  font-weight: 600;
}
.gfx-ref-chip:hover {
  background: var(--brand-100, #D2E2EC);
  color: var(--brand-900, #071E31);
}
.gfx-ref-chip-name { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.gfx-ref-chip-dl { color: var(--brand-500, #3B6B94); flex-shrink: 0; }

/* Version cards (Files & Versions tab) */
.gfx-version-list { display: flex; flex-direction: column; gap: 10px; margin-top: 18px; }
.gfx-version-item {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 14px;
  background: var(--bg-subtle, #F8FAFC);
  border: 1px solid var(--border, #E7E9F2);
  border-radius: 12px;
  padding: 13px 18px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.gfx-version-item:hover {
  border-color: var(--brand-200, #A8C5DA);
  box-shadow: 0 3px 10px rgba(15, 23, 42, 0.06);
}
.gfx-version-badge {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: var(--brand-gradient);
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.gfx-version-thumb {
  cursor: pointer;
  position: relative;
  /* No overflow:hidden here — the v# tag below is intentionally pinned to
     the corner and would get clipped by it. The image itself is rounded
     via its own border-radius instead. */
}
.gfx-version-thumb-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
  display: block;
}
.gfx-version-thumb-tag {
  position: absolute;
  bottom: -4px;
  right: -4px;
  min-width: 18px;
  height: 16px;
  background: rgba(15, 23, 42, 0.85);
  border: 1.5px solid #fff;
  color: #fff;
  font-size: 9px;
  font-weight: 700;
  line-height: 1;
  padding: 0 4px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.gfx-preview-image {
  max-width: 100%;
  max-height: 70vh;
  display: block;
  margin: 0 auto;
  border-radius: 8px;
}
.gfx-preview-frame {
  width: 100%;
  height: 70vh;
  border: none;
  border-radius: 8px;
}
.gfx-preview-unsupported {
  text-align: center;
  padding: 40px 0;
  color: var(--text-secondary, #64748B);
}
.gfx-version-info { flex: 1 1; min-width: 0; }
.gfx-version-name { font-size: 14px; font-weight: 600; color: var(--text-primary, #0F172A); }
.gfx-version-meta { font-size: 12px; color: var(--text-muted, #94A3B8); margin-top: 2px; }
.gfx-version-actions { display: flex; align-items: center; gap: 8px; flex-shrink: 0; }
.gfx-version-icon-btn.ant-btn {
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
  padding: 0 !important;
  border-radius: 9999px !important;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border, #E7E9F2) !important;
  color: var(--text-secondary, #475569) !important;
  background: #ffffff !important;
}
.gfx-version-icon-btn.ant-btn:hover {
  border-color: var(--brand-300, #7CA7C2) !important;
  color: var(--brand-500, #3B6B94) !important;
}
.gfx-version-icon-btn--danger.ant-btn:hover {
  border-color: #ffccc7 !important;
  background: #fff1f0 !important;
  color: #cf1322 !important;
}
.gfx-version-note-editor { display: flex; align-items: flex-start; gap: 8px; margin-top: 6px; width: 100%; }
.gfx-version-note-editor .ant-input { border-radius: 8px; }
.gfx-version-delete-pending { margin-top: 4px; font-size: 12px; font-weight: 600; color: #B45309; }
.gfx-version-delete-rejected { margin-top: 4px; font-size: 12px; color: #991B1B; }
/* The filename doubles as the "view" action -- hover reveals it's clickable
   instead of needing a separate "View" button next to Download. */
.gfx-version-name-row { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.gfx-version-name--link { text-decoration: none; cursor: pointer; transition: color 0.15s ease; }
.gfx-version-name--link:hover { color: var(--brand-500, #3B6B94); text-decoration: underline; }
.gfx-version-inline-dl {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 9999px;
  color: var(--brand-500, #3B6B94);
  background: var(--brand-50, #EAF1F6);
  flex-shrink: 0;
  transition: background 0.15s ease, color 0.15s ease;
}
.gfx-version-inline-dl:hover { background: var(--brand-500, #3B6B94); color: #ffffff; }

/* Delivery-date extension banner (pending decision) */
.gfx-ext-banner {
  margin-top: 16px;
  padding: 14px 16px;
  background: #FFFBEA;
  border: 1px solid #FDE68A;
  border-radius: 12px;
}
.gfx-ext-banner-text { font-size: 13.5px; color: #78350F; line-height: 1.6; }
.gfx-ext-banner-reason { margin-top: 4px; font-style: italic; color: #92651A; }
.gfx-ext-banner-actions { display: flex; gap: 8px; margin-top: 10px; flex-wrap: wrap; }
.gfx-ext-btn.ant-btn {
  height: 32px !important;
  padding: 0 16px !important;
  border-radius: 9999px !important;
  font-weight: 600 !important;
  font-size: 12.5px !important;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.gfx-ext-btn--approve.ant-btn {
  background: var(--brand-gradient) !important;
  border: none !important;
  color: #ffffff !important;
}
.gfx-ext-btn--approve.ant-btn:hover { opacity: 0.9; color: #ffffff !important; }
.gfx-ext-btn--reject.ant-btn {
  background: #ffffff !important;
  border: 1px solid #FCA5A5 !important;
  color: #B91C1C !important;
}
.gfx-ext-btn--reject.ant-btn:hover { background: #FEF2F2 !important; }
.gfx-ext-btn--reassign.ant-btn {
  background: #ffffff !important;
  border: 1px solid var(--border, #E7E9F2) !important;
  color: var(--text-secondary, #475569) !important;
}
.gfx-ext-btn--reassign.ant-btn:hover {
  border-color: var(--brand-300, #7CA7C2) !important;
  color: var(--brand-500, #3B6B94) !important;
}

/* Tabs (pill style) */
.ant-tabs.gfx-tabs .ant-tabs-nav {
  background: #ffffff;
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 14px;
  padding: 6px 8px;
  margin-bottom: 20px !important;
}
.ant-tabs.gfx-tabs .ant-tabs-nav::before { border-bottom: none !important; }
.ant-tabs.gfx-tabs .ant-tabs-ink-bar { display: none !important; }
.ant-tabs.gfx-tabs .ant-tabs-tab {
  padding: 9px 18px !important;
  border-radius: 9px !important;
  margin: 0 2px !important;
  background: transparent !important;
  transition: background 0.16s ease !important;
}
.ant-tabs.gfx-tabs .ant-tabs-tab:hover { background: rgba(59,107,148,0.07) !important; }
.ant-tabs.gfx-tabs .ant-tabs-tab .ant-tabs-tab-btn { font-size: 13.5px; font-weight: 500; color: #5a7080; }
.ant-tabs.gfx-tabs .ant-tabs-tab.ant-tabs-tab-active {
  background: var(--brand-gradient) !important;
  box-shadow: 0 3px 10px rgba(59,107,148,0.30);
}
.ant-tabs.gfx-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #ffffff !important;
  font-weight: 700;
  text-shadow: none;
}

/* Discussion: composer + chat bubbles */
.gfx-comment-composer { display: flex; flex-direction: column; align-items: flex-end; gap: 10px; margin-bottom: 22px; }
.gfx-comment-composer .ant-input {
  border-radius: 12px !important;
  border-color: var(--border, #E7E9F2) !important;
  background: var(--bg-subtle, #F8FAFC) !important;
  padding: 12px 14px !important;
  font-size: 13.5px !important;
}
.gfx-comment-composer .ant-input:focus {
  border-color: var(--brand-500, #3B6B94) !important;
  box-shadow: 0 0 0 3px rgba(59, 107, 148, 0.12) !important;
  background: #ffffff !important;
}
.gfx-comment-post-btn.ant-btn {
  border-radius: 9999px !important;
  height: 36px !important;
  padding: 0 20px !important;
  font-weight: 600 !important;
  background: var(--brand-gradient) !important;
  border: none !important;
  color: #fff !important;
  box-shadow: 0 3px 10px rgba(59, 107, 148, 0.28) !important;
}
.gfx-comment-post-btn.ant-btn:hover,
.gfx-comment-post-btn.ant-btn:focus {
  color: #fff !important;
}
.gfx-comment-list { display: flex; flex-direction: column; gap: 14px; }
.gfx-comment { display: flex; align-items: flex-start; gap: 12px; }
.gfx-comment-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--brand-gradient);
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.gfx-comment-bubble {
  flex: 1 1;
  min-width: 0;
  background: var(--bg-subtle, #F8FAFC);
  border: 1px solid var(--border, #E7E9F2);
  border-radius: 4px 14px 14px 14px;
  padding: 11px 15px;
}
.gfx-comment-head { display: flex; align-items: baseline; justify-content: space-between; gap: 10px; margin-bottom: 4px; }
.gfx-comment-author { font-size: 13px; font-weight: 700; color: var(--text-primary, #0F172A); }
.gfx-comment-time { font-size: 11px; color: var(--text-muted, #94A3B8); white-space: nowrap; }
.gfx-comment-text { font-size: 13.5px; color: var(--text-secondary, #475569); line-height: 1.6; margin: 0; white-space: pre-wrap; overflow-wrap: break-word; }

/* Audit trail */
.gfx-audit { padding-top: 4px; }
.gfx-audit-action { font-weight: 700; color: var(--text-primary, #0F172A); text-transform: capitalize; }
.gfx-audit-actor { font-weight: 600; color: var(--brand-500, #3B6B94); }
.gfx-audit-time { font-size: 12px; color: var(--text-muted, #94A3B8); margin-top: 2px; }
.gfx-audit-comment {
  margin-top: 6px;
  font-size: 13px;
  color: var(--text-secondary, #475569);
  background: var(--bg-subtle, #F8FAFC);
  border: 1px solid var(--border, #E7E9F2);
  border-radius: 8px;
  padding: 8px 12px;
  display: inline-block;
}

@media (max-width: 992px) {
  .gfx-meta-grid { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 560px) {
  .gfx-meta-grid { grid-template-columns: 1fr; }
}

/* Blog Description modal — document-styled outline builder. Near-fullscreen,
   generously padded "page" card so drafting the outline feels like working
   on a document rather than filling a cramped form (direct user feedback on
   the old flat TextArea + per-section image-upload-button layout). */
.blog-desc-modal .ant-modal-content { border-radius: 12px; overflow: hidden; }
/* Wins over the global unscoped ".ant-modal-header { padding: 20px
   !important; }" rule in main.css — only !important can override another
   !important, regardless of selector specificity. */
.blog-desc-modal .ant-modal-header { padding: 22px 24px 18px !important; }
.blog-desc-toolbar {
  position: sticky;
  top: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 8px 24px;
  background: #fff;
  border-bottom: 1px solid var(--border, #E7E9F2);
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.05);
}
.blog-desc-toolbar-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: var(--text-secondary, #475569);
  cursor: pointer;
  font-size: 16px;
  transition: background 0.12s ease, color 0.12s ease;
}
.blog-desc-toolbar-btn:hover { background: var(--bg-subtle, #F1F5F9); color: var(--text-primary, #0F172A); }
.blog-desc-toolbar-btn.active { background: var(--brand-turquoise-tint, #E0F7F5); color: var(--brand-steel-blue, #1F4E79); }
.blog-desc-toolbar-divider {
  width: 1px;
  height: 22px;
  margin: 0 8px;
  background: var(--border, #E7E9F2);
}
.blog-desc-toolbar-style-select {
  position: relative;
  display: inline-flex;
  align-items: center;
  min-width: 116px;
  height: 34px;
  padding: 0;
  border-radius: 8px;
  transition: background 0.12s ease;
}
.blog-desc-toolbar-style-select:hover { background: var(--bg-subtle, #F1F5F9); }
.blog-desc-toolbar-style-select select {
  width: 100%;
  height: 100%;
  border: 0;
  background: transparent;
  color: var(--text-primary, #0F172A);
  font-size: 14px;
  font-weight: 700;
  appearance: none;
  outline: none;
  padding: 0 26px 0 12px;
  cursor: pointer;
}
.blog-desc-toolbar-style-caret {
  position: absolute;
  right: 10px;
  color: var(--text-muted, #94A3B8);
  pointer-events: none;
  font-size: 10px;
}
.blog-desc-page {
  padding: 56px 64px 64px;
  max-width: 820px;
  margin: 0 auto;
}
.blog-desc-page-eyebrow {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-muted, #94A3B8);
  margin-bottom: 8px;
}
.blog-desc-page-title {
  font-family: Georgia, "Times New Roman", serif;
  font-size: 32px;
  line-height: 1.3;
  font-weight: 700;
  color: var(--text-primary, #0F172A);
  margin: 0 0 20px;
}
.blog-desc-page-divider { margin: 32px 0; border-color: var(--border, #E7E9F2); }
.blog-desc-section { margin-bottom: 36px; }
.blog-desc-section-label {
  font-family: Georgia, "Times New Roman", serif;
  font-size: 17px;
  font-weight: 700;
  color: var(--text-primary, #0F172A);
  margin-bottom: 14px;
}
.blog-desc-header-block {
  padding: 22px 24px 24px;
  margin-bottom: 20px;
  background: #fff;
  border: 1px solid var(--border, #E7E9F2);
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  transition: border-color 0.12s ease, box-shadow 0.12s ease;
}
.blog-desc-header-block:focus-within {
  border-color: var(--brand-turquoise, #14B8A6);
  box-shadow: 0 0 0 3px var(--brand-turquoise-tint, #E0F7F5);
}
.blog-desc-subheader-block {
  padding: 16px 20px 18px;
  margin: 16px 0 0 24px;
  background: var(--bg-subtle, #F8FAFC);
  border: 1px solid var(--border, #E7E9F2);
  border-left: 3px solid var(--brand-turquoise, #14B8A6);
  border-radius: 8px;
  transition: border-color 0.12s ease, box-shadow 0.12s ease;
}
.blog-desc-subheader-block:focus-within {
  box-shadow: 0 0 0 3px var(--brand-turquoise-tint, #E0F7F5);
}
.blog-desc-header-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}
.blog-desc-header-title-input {
  font-size: 17px;
  font-weight: 700;
  font-family: Georgia, "Times New Roman", serif;
  padding-left: 0;
}
.blog-desc-header-title-input.ant-input::placeholder { color: var(--text-muted, #94A3B8); font-weight: 600; }
.blog-desc-subheader-title-input {
  font-size: 14px;
  font-weight: 600;
  padding-left: 0;
}
.blog-desc-preview-img {
  max-width: 100%;
  border-radius: 8px;
  margin-top: 8px;
}
.blog-desc-export-actions { display: flex; gap: 12px; margin-bottom: 20px; }
`, "",{"version":3,"sources":["webpack://./src/assets/styles/components.css"],"names":[],"mappings":"AAAA;;;;0EAI0E;;AAE1E,wEAAwE;AACxE;;EAEE,qCAAqC;EACrC,0CAA0C;EAC1C,uCAAuC;EACvC,6BAA6B;EAC7B,sDAAsD;AACxD;AACA;EACE,uCAAuC;AACzC;AACA;EACE,iDAAiD;EACjD,gBAAgB;EAChB,oCAAoC;AACtC;AACA;EACE,2CAA2C;EAC3C,sCAAsC;EACtC,kCAAkC;EAClC,qCAAqC;EACrC,0BAA0B;AAC5B;AACA;EACE,uBAAuB;AACzB;;AAEA,0EAA0E;AAC1E;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,gBAAgB;EAChB;;kGAEgG;AAClG;;AAEA;;EAEE,4CAA4C;EAC5C,uBAAuB;EACvB,sBAAsB;EACtB,+BAA+B;AACjC;AACA;;;EAGE,kDAAkD;EAClD,sBAAsB;EACtB,2BAA2B;EAC3B,iDAAiD;AACnD;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,iDAAiD;EACjD,uCAAuC;AACzC;AACA;;EAEE,yCAAyC;EACzC,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;AACvC;AACA;EACE,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;EACnC,mCAAmC;EACnC,sCAAsC;AACxC;AACA;;EAEE,mCAAmC;AACrC;;AAEA;;;mBAGmB;AACnB;;EAEE,UAAU;EACV,4CAA4C;EAC5C,sBAAsB;EACtB,oCAAoC;EACpC,eAAe;AACjB;AACA;;EAEE,8BAA8B;EAC9B,gCAAgC;AAClC;AACA;;EAEE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,4CAA4C;EAC5C,uBAAuB;EACvB,qCAAqC;AACvC;AACA;EACE,kDAAkD;AACpD;;AAEA,iFAAiF;AACjF;;;;EAIE,qCAAqC;EACrC,iDAAiD;EACjD,0BAA0B;EAC1B,oCAAoC;EACpC,+GAA+G;AACjH;AACA;EACE,wBAAwB;AAC1B;AACA;;;EAGE,yCAAyC;AAC3C;AACA;;;;;EAKE,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,qCAAqC;EACrC,6CAA6C;EAC7C,+GAA+G;AACjH;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;;;EAGE,qCAAqC;AACvC;AACA;EACE,uCAAuC;AACzC;;AAEA,yEAAyE;AACzE;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,uCAAuC;EACvC,mCAAmC;EACnC,0CAA0C;EAC1C,kCAAkC;EAClC,yBAAyB;EACzB,sBAAsB;EACtB,iDAAiD;AACnD;AACA;EACE,sCAAsC;EACtC,4BAA4B;AAC9B;AACA;EACE,sDAAsD;AACxD;AACA;;EAEE,sCAAsC;AACxC;;AAEA,6EAA6E;AAC7E;EACE,qCAAqC;EACrC,sCAAsC;EACtC,+CAA+C;AACjD;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yCAAyC;EACzC,sCAAsC;AACxC;AACA;EACE,kCAAkC;EAClC,+BAA+B;AACjC;AACA;;EAEE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA,mFAAmF;AACnF;EACE,4CAA4C;EAC5C,0BAA0B;EAC1B,kCAAkC;AACpC;AACA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,gBAAgB;AAClB;AACA;;EAEE,2CAA2C;EAC3C,sCAAsC;EACtC,qCAAqC;AACvC;AACA;;EAEE,qCAAqC;AACvC;AACA;EACE,mCAAmC;EACnC,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA,oFAAoF;AACpF;EACE,qCAAqC;EACrC,uCAAuC;EACvC,uBAAuB;EACvB,+BAA+B;AACjC;AACA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,sDAAsD;AACxD;AACA;EACE,sCAAsC;AACxC;;AAEA,0EAA0E;AAC1E;EACE,uCAAuC;AACzC;AACA;EACE,uCAAuC;EACvC,yCAAyC;AAC3C;AACA;;EAEE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,kCAAkC;EAClC,+BAA+B;AACjC;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,6CAA6C;AAC/C;;AAEA,iFAAiF;AACjF;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA,yFAAyF;AACzF;EACE;;IAEE,6BAA6B;IAC7B,kCAAkC;EACpC;AACF;;AAEA,gFAAgF;AAChF;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA,8FAA8F;AAC9F;EACE,0BAA0B;EAC1B,sDAAsD;EACtD,6BAA6B;AAC/B;AACA;EACE,qCAAqC;AACvC;AACA;EACE,+BAA+B;EAC/B,mCAAmC;AACrC;AACA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,mBAAmB;EACnB,mDAAmD;AACrD;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gCAAgC;EAChC,2CAA2C;EAC3C,mBAAmB;AACrB;AACA;EACE,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,qBAAqB;EACrB,uCAAuC;EACvC,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,mDAAmD;EACnD,gDAAgD;EAChD,8BAA8B;AAChC;AACA;EACE,kDAAkD;EAClD,2CAA2C;AAC7C;AACA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,+BAA+B;AACjC;;AAEA;;;;mEAImE;AACnE;EACE,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;EACjC,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,qCAAqC;EACrC,2CAA2C;EAC3C,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,cAAc;AAChB;AACA,mCAAmC,UAAU,EAAE,WAAW,EAAE;AAC5D;EACE,uBAAuB;EACvB,gCAAgC;EAChC,sDAAsD;EACtD,gDAAgD;EAChD,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,gDAAgD;EAChD,yBAAyB;EACzB,iDAAiD;AACnD;AACA;EACE,8CAA8C;EAC9C,gDAAgD;EAChD,yBAAyB;AAC3B;AACA;EACE,8CAA8C;AAChD;;AAEA;;;;;uDAKuD;AACvD;EACE,uBAAuB;EACvB,gCAAgC;EAChC,0BAA0B;EAC1B,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR;;;;;iBAKe;EACf,kBAAkB;AACpB;;AAEA,oBAAoB,kBAAkB,EAAE,qBAAqB,EAAE;AAC/D,oCAAoC,mBAAmB,EAAE;AACzD,oCAAoC,mBAAmB,EAAE;AACzD,oCAAoC,mBAAmB,EAAE;AACzD,oCAAoC,mBAAmB,EAAE;;AAEzD,eAAe;AACf;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA;EACE,qCAAqC;EACrC,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,yBAAyB;AAC3B;AACA,wBAAwB,mBAAmB,EAAE,qBAAqB,EAAE;AACpE,wCAAwC,cAAc,EAAE;;AAExD,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,gDAAgD;EAChD,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,iBAAiB;EACjB,SAAS;EACT,qBAAqB;AACvB;AACA;;;;;;;;;;;;;;;;;;sEAkBsE;AACtE;EACE,mBAAmB;AACrB;AACA;;;;;;;;;;;;;2DAa2D;AAC3D;EACE,SAAS;AACX;AACA;;;;;;;;;;;iDAWiD;AACjD;EACE,gBAAgB;AAClB;AACA;;EAEE,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;;;wEAGwE;AACxE;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;;;;uEAIuE;AACvE,mCAAmC,gBAAgB,EAAE;AACrD,qCAAqC,kBAAkB,EAAE;AACzD,oCAAoC,iBAAiB,EAAE;AACvD,sCAAsC,mBAAmB,EAAE;;AAE3D;;;;;;;;;;aAUa;AACb;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB,iBAAiB,gBAAgB,EAAE;AACnC,iBAAiB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE;AAC3D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,oCAAoC;EACpC,2CAA2C;EAC3C,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;AACA,qBAAqB,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACrF,mBAAmB,gCAAgC,EAAE,cAAc,EAAE;;AAErE,yCAAyC;AACzC,oBAAoB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE,gBAAgB,EAAE;AACxF;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,qCAAqC;EACrC,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,0DAA0D;AAC5D;AACA;EACE,uCAAuC;EACvC,6CAA6C;AAC/C;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;EACjC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB;;yCAEuC;AACzC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kCAAkC;EAClC,wBAAwB;EACxB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,qCAAqC;AACvC;AACA,oBAAoB,SAAO,EAAE,YAAY,EAAE;AAC3C,oBAAoB,eAAe,EAAE,gBAAgB,EAAE,mCAAmC,EAAE;AAC5F,oBAAoB,eAAe,EAAE,iCAAiC,EAAE,eAAe,EAAE;AACzF,uBAAuB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,cAAc,EAAE;AACrF;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,qBAAqB;EACrB,gCAAgC;EAChC,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,mDAAmD;EACnD,gDAAgD;EAChD,8BAA8B;AAChC;AACA;EACE,kDAAkD;EAClD,2CAA2C;AAC7C;AACA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA,2BAA2B,aAAa,EAAE,uBAAuB,EAAE,QAAQ,EAAE,eAAe,EAAE,WAAW,EAAE;AAC3G,sCAAsC,kBAAkB,EAAE;AAC1D,8BAA8B,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAClG,+BAA+B,eAAe,EAAE,eAAe,EAAE,cAAc,EAAE;AACjF;kEACkE;AAClE,wBAAwB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE;AACvF,0BAA0B,qBAAqB,EAAE,eAAe,EAAE,4BAA4B,EAAE;AAChG,gCAAgC,gCAAgC,EAAE,0BAA0B,EAAE;AAC9F;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,gCAAgC;EAChC,oCAAoC;EACpC,cAAc;EACd,mDAAmD;AACrD;AACA,+BAA+B,qCAAqC,EAAE,cAAc,EAAE;;AAEtF,sDAAsD;AACtD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;AACA,uBAAuB,iBAAiB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AAC5E,yBAAyB,eAAe,EAAE,kBAAkB,EAAE,cAAc,EAAE;AAC9E,0BAA0B,aAAa,EAAE,QAAQ,EAAE,gBAAgB,EAAE,eAAe,EAAE;AACtF;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,gCAAgC;EAChC,2BAA2B;EAC3B,4BAA4B;EAC5B,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,4CAA4C;EAC5C,uBAAuB;EACvB,yBAAyB;AAC3B;AACA,sCAAsC,YAAY,EAAE,yBAAyB,EAAE;AAC/E;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;AAC3B;AACA,qCAAqC,8BAA8B,EAAE;AACrE;EACE,8BAA8B;EAC9B,mDAAmD;EACnD,gDAAgD;AAClD;AACA;EACE,kDAAkD;EAClD,2CAA2C;AAC7C;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;AAChC;AACA,2CAA2C,8BAA8B,EAAE;AAC3E,uCAAuC,wBAAwB,EAAE;AACjE;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,wBAAwB;EACxB,kCAAkC;EAClC,4CAA4C;AAC9C;AACA,yCAAyC,4CAA4C,EAAE;AACvF,qDAAqD,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC1G;EACE,4CAA4C;EAC5C,4CAA4C;AAC9C;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,wCAAwC;AACxC,wBAAwB,aAAa,EAAE,sBAAsB,EAAE,qBAAqB,EAAE,SAAS,EAAE,mBAAmB,EAAE;AACtH;EACE,8BAA8B;EAC9B,+CAA+C;EAC/C,gDAAgD;EAChD,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,kDAAkD;EAClD,yDAAyD;EACzD,8BAA8B;AAChC;AACA;EACE,gCAAgC;EAChC,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,4CAA4C;EAC5C,uBAAuB;EACvB,sBAAsB;EACtB,0DAA0D;AAC5D;AACA;;EAEE,sBAAsB;AACxB;AACA,oBAAoB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AACtE,eAAe,aAAa,EAAE,uBAAuB,EAAE,SAAS,EAAE;AAClE;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,SAAO;EACP,YAAY;EACZ,qCAAqC;EACrC,wCAAwC;EACxC,iCAAiC;EACjC,kBAAkB;AACpB;AACA,oBAAoB,aAAa,EAAE,qBAAqB,EAAE,8BAA8B,EAAE,SAAS,EAAE,kBAAkB,EAAE;AACzH,sBAAsB,eAAe,EAAE,gBAAgB,EAAE,mCAAmC,EAAE;AAC9F,oBAAoB,eAAe,EAAE,iCAAiC,EAAE,mBAAmB,EAAE;AAC7F,oBAAoB,iBAAiB,EAAE,qCAAqC,EAAE,gBAAgB,EAAE,SAAS,EAAE,qBAAqB,EAAE,yBAAyB,EAAE;;AAE7J,gBAAgB;AAChB,aAAa,gBAAgB,EAAE;AAC/B,oBAAoB,gBAAgB,EAAE,mCAAmC,EAAE,0BAA0B,EAAE;AACvG,mBAAmB,gBAAgB,EAAE,gCAAgC,EAAE;AACvE,kBAAkB,eAAe,EAAE,iCAAiC,EAAE,eAAe,EAAE;AACvF;EACE,eAAe;EACf,eAAe;EACf,qCAAqC;EACrC,qCAAqC;EACrC,wCAAwC;EACxC,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB,qCAAqC,EAAE;AAC1D;AACA;EACE,iBAAiB,0BAA0B,EAAE;AAC/C;;AAEA;;;qEAGqE;AACrE,sCAAsC,mBAAmB,EAAE,gBAAgB,EAAE;AAC7E;;oDAEoD;AACpD,qCAAqC,kCAAkC,EAAE;AACzE;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,+CAA+C;EAC/C,4CAA4C;AAC9C;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;EACf,eAAe;EACf,mDAAmD;AACrD;AACA,+BAA+B,qCAAqC,EAAE,mCAAmC,EAAE;AAC3G,gCAAgC,gDAAgD,EAAE,uCAAuC,EAAE;AAC3H;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,iCAAiC;AACnC;AACA,wCAAwC,qCAAqC,EAAE;AAC/E;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,iCAAiC;EACjC,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;AACpB;AACA;EACE,8CAA8C;EAC9C,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;AAClB;AACA,0BAA0B,cAAc,EAAE,oCAAoC,EAAE;AAChF,qBAAqB,mBAAmB,EAAE;AAC1C;EACE,8CAA8C;EAC9C,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,4CAA4C;EAC5C,0DAA0D;AAC5D;AACA;EACE,6CAA6C;EAC7C,0DAA0D;AAC5D;AACA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,qCAAqC;EACrC,wCAAwC;EACxC,sDAAsD;EACtD,kBAAkB;EAClB,0DAA0D;AAC5D;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,8CAA8C;EAC9C,eAAe;AACjB;AACA,uDAAuD,iCAAiC,EAAE,gBAAgB,EAAE;AAC5G;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;AACA,4BAA4B,aAAa,EAAE,SAAS,EAAE,mBAAmB,EAAE","sourcesContent":["/* =====================================================================\n   Imergey Admin — Global Components & States\n   Loaded after chrome.css. Restyles antd v4 + bootstrap primitives via\n   overrides only (no markup changes).\n   ===================================================================== */\n\n/* ============================== Cards ============================== */\n.ant-card,\n.ant-card.criclebox {\n  border-radius: var(--r-lg) !important;\n  border: 1px solid var(--border) !important;\n  box-shadow: var(--shadow-sm) !important;\n  background: var(--bg-surface);\n  transition: box-shadow var(--dur-base) var(--ease-out);\n}\n.ant-card.criclebox:hover {\n  box-shadow: var(--shadow-md) !important;\n}\n.ant-card-head {\n  border-bottom: 1px solid var(--border) !important;\n  min-height: 62px;\n  padding: 0 var(--space-6) !important;\n}\n.ant-card-head-title {\n  font-family: var(--font-display) !important;\n  font-weight: var(--fw-bold) !important;\n  font-size: var(--fs-lg) !important;\n  color: var(--text-primary) !important;\n  padding: 18px 0 !important;\n}\n.ant-card-body {\n  padding: var(--space-6);\n}\n\n/* ============================== Buttons ============================== */\n.ant-btn {\n  border-radius: var(--r-md) !important;\n  font-weight: var(--fw-semibold);\n  box-shadow: none;\n  transition: transform var(--dur-fast) var(--ease-out),\n    box-shadow var(--dur-fast) var(--ease-out), background var(--dur-fast) var(--ease-out),\n    border-color var(--dur-fast) var(--ease-out), color var(--dur-fast) var(--ease-out) !important;\n}\n\n.ant-btn-primary,\nbutton.ant-btn.ant-btn-primary {\n  background: var(--brand-gradient) !important;\n  border: none !important;\n  color: #fff !important;\n  box-shadow: var(--shadow-brand);\n}\n.ant-btn-primary:hover,\n.ant-btn-primary:focus,\nbutton.ant-btn.ant-btn-primary:hover {\n  background: var(--brand-gradient-hover) !important;\n  color: #fff !important;\n  transform: translateY(-1px);\n  box-shadow: 0 14px 30px -6px rgba(7, 29, 49, 0.5);\n}\n.ant-btn-primary:active {\n  transform: translateY(0);\n}\n\n.ant-btn-default {\n  background: var(--bg-surface);\n  border: 1px solid var(--border-strong) !important;\n  color: var(--text-secondary) !important;\n}\n.ant-btn-default:hover,\n.ant-btn-default:focus {\n  border-color: var(--brand-400) !important;\n  color: var(--brand-600) !important;\n  transform: translateY(-1px);\n}\n\n.ant-btn-dangerous {\n  color: var(--error) !important;\n  border-color: var(--error) !important;\n}\n.ant-btn-dangerous.ant-btn-primary {\n  background: var(--error) !important;\n  color: #fff !important;\n}\n\n.ant-btn[disabled],\n.ant-btn[disabled]:hover {\n  opacity: 0.55;\n  transform: none !important;\n  box-shadow: none !important;\n  background: var(--n-100) !important;\n  color: var(--text-muted) !important;\n  border-color: var(--border) !important;\n}\n.ant-btn-primary[disabled],\n.ant-btn-primary[disabled]:hover {\n  background: var(--n-200) !important;\n}\n\n/* Status-indicator buttons (e.g. \"Original Contract Exists\", \"Manual\n   Onboarding Active\") are disabled to prevent re-clicking, but they still\n   need to read as \"on\"/branded rather than washed-out grey like a truly\n   inert control. */\n.ant-btn.gfx-btn-active[disabled],\n.ant-btn.gfx-btn-active[disabled]:hover {\n  opacity: 1;\n  background: var(--brand-gradient) !important;\n  color: #fff !important;\n  border-color: transparent !important;\n  cursor: default;\n}\n.ant-btn.gfx-btn-active.gfx-btn-success[disabled],\n.ant-btn.gfx-btn-active.gfx-btn-success[disabled]:hover {\n  background: #27ae60 !important;\n  border-color: #27ae60 !important;\n}\n.ant-btn.gfx-btn-active.gfx-btn-warning[disabled],\n.ant-btn.gfx-btn-active.gfx-btn-warning[disabled]:hover {\n  background: #f39c12 !important;\n  border-color: #f39c12 !important;\n}\n\n.btn-primary {\n  background: var(--brand-gradient) !important;\n  border: none !important;\n  border-radius: var(--r-md) !important;\n}\n.btn-primary:hover {\n  background: var(--brand-gradient-hover) !important;\n}\n\n/* ============================== Inputs / Forms ============================== */\n.ant-input,\n.ant-input-affix-wrapper,\n.ant-input-number,\n.ant-picker {\n  border-radius: var(--r-md) !important;\n  border: 1px solid var(--border-strong) !important;\n  color: var(--text-primary);\n  font-size: var(--fs-base) !important;\n  transition: border-color var(--dur-fast) var(--ease-out), box-shadow var(--dur-fast) var(--ease-out) !important;\n}\n.ant-input::placeholder {\n  color: var(--text-muted);\n}\n.ant-input:hover,\n.ant-input-affix-wrapper:hover,\n.ant-picker:hover {\n  border-color: var(--brand-300) !important;\n}\n.ant-input:focus,\n.ant-input-focused,\n.ant-input-affix-wrapper:focus,\n.ant-input-affix-wrapper-focused,\n.ant-picker-focused {\n  border-color: var(--brand-500) !important;\n  box-shadow: 0 0 0 3px var(--ring) !important;\n}\n\n.ant-select:not(.ant-select-disabled) .ant-select-selector {\n  border-radius: var(--r-md) !important;\n  border-color: var(--border-strong) !important;\n  transition: border-color var(--dur-fast) var(--ease-out), box-shadow var(--dur-fast) var(--ease-out) !important;\n}\n.ant-select:not(.ant-select-disabled):hover .ant-select-selector {\n  border-color: var(--brand-300) !important;\n}\n.ant-select-focused:not(.ant-select-disabled) .ant-select-selector {\n  border-color: var(--brand-500) !important;\n  box-shadow: 0 0 0 3px var(--ring) !important;\n}\n\n.ant-form-item-label > label {\n  font-weight: var(--fw-semibold);\n  color: var(--text-primary);\n  font-size: var(--fs-sm);\n}\n.ant-form-item-explain-error {\n  color: var(--error);\n  font-size: var(--fs-xs);\n  margin-top: 4px;\n}\n.ant-form-item-has-error .ant-input,\n.ant-form-item-has-error .ant-input-affix-wrapper,\n.ant-form-item-has-error .ant-select .ant-select-selector {\n  border-color: var(--error) !important;\n}\n.ant-form-item-has-success.ant-form-item-has-feedback .ant-input {\n  border-color: var(--success) !important;\n}\n\n/* ============================== Tables ============================== */\n.ant-table {\n  background: transparent;\n  border-radius: var(--r-md);\n}\n.ant-table-thead > tr > th {\n  background: var(--bg-subtle) !important;\n  color: var(--text-muted) !important;\n  font-weight: var(--fw-semibold) !important;\n  font-size: var(--fs-xs) !important;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  border-bottom: 1px solid var(--border) !important;\n}\n.ant-table-tbody > tr > td {\n  border-bottom: 1px solid var(--border);\n  color: var(--text-secondary);\n}\n.ant-table-tbody > tr {\n  transition: background var(--dur-fast) var(--ease-out);\n}\n.ant-table-tbody > tr:hover > td,\n.ant-table-tbody > tr.ant-table-row:hover > td {\n  background: var(--bg-hover) !important;\n}\n\n/* ============================== Pagination ============================== */\n.ant-pagination-item {\n  border-radius: var(--r-sm) !important;\n  border-color: var(--border) !important;\n  transition: all var(--dur-fast) var(--ease-out);\n}\n.ant-pagination-item a {\n  color: var(--text-secondary);\n}\n.ant-pagination-item:hover {\n  border-color: var(--brand-400) !important;\n}\n.ant-pagination-item:hover a {\n  color: var(--brand-600);\n}\n.ant-pagination-item-active {\n  border-color: var(--brand-500) !important;\n  background: var(--brand-50) !important;\n}\n.ant-pagination-item-active a {\n  color: var(--brand-700) !important;\n  font-weight: var(--fw-semibold);\n}\n.ant-pagination-prev .ant-pagination-item-link,\n.ant-pagination-next .ant-pagination-item-link {\n  border-radius: var(--r-sm) !important;\n  border-color: var(--border) !important;\n}\n\n/* ============================== Modals / Drawers ============================== */\n.ant-modal-mask {\n  background: rgba(15, 23, 42, 0.5) !important;\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n}\n.ant-modal-content {\n  border-radius: var(--r-xl) !important;\n  box-shadow: var(--shadow-xl) !important;\n  overflow: hidden;\n}\n.ant-modal-title,\n.modal_title_cls {\n  font-family: var(--font-display) !important;\n  font-weight: var(--fw-bold) !important;\n  color: var(--text-primary) !important;\n}\n.ant-modal-footer .ant-btn,\n.ant-modal.tab_modal .ant-modal-footer .ant-btn {\n  border-radius: var(--r-md) !important;\n}\n.ant-drawer-content {\n  border-top-left-radius: var(--r-lg);\n  border-bottom-left-radius: var(--r-lg);\n}\n.ant-drawer-header {\n  border-bottom: 1px solid var(--border);\n}\n.ant-drawer-title {\n  font-family: var(--font-display);\n  font-weight: var(--fw-bold);\n  color: var(--text-primary);\n}\n\n/* ============================== Dropdowns / Menus ============================== */\n.ant-dropdown-menu {\n  border-radius: var(--r-md) !important;\n  box-shadow: var(--shadow-lg) !important;\n  padding: 6px !important;\n  border: 1px solid var(--border);\n}\n.ant-dropdown-menu-item {\n  border-radius: var(--r-sm) !important;\n  font-weight: var(--fw-medium);\n  transition: background var(--dur-fast) var(--ease-out);\n}\n.ant-dropdown-menu-item:hover {\n  background: var(--bg-hover) !important;\n}\n\n/* ============================== Accents ============================== */\n.ant-switch-checked {\n  background: var(--brand-600) !important;\n}\n.ant-checkbox-checked .ant-checkbox-inner {\n  background: var(--brand-600) !important;\n  border-color: var(--brand-600) !important;\n}\n.ant-checkbox-wrapper:hover .ant-checkbox-inner,\n.ant-checkbox:hover .ant-checkbox-inner {\n  border-color: var(--brand-500) !important;\n}\n.ant-radio-checked .ant-radio-inner {\n  border-color: var(--brand-600) !important;\n}\n.ant-radio-inner::after {\n  background-color: var(--brand-600) !important;\n}\n.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: var(--brand-600) !important;\n  font-weight: var(--fw-semibold);\n}\n.ant-tabs-ink-bar {\n  background: var(--brand-gradient) !important;\n}\n.ant-spin-dot-item {\n  background-color: var(--brand-600) !important;\n}\n\n/* ============================== Empty / states ============================== */\n.ant-empty-description {\n  color: var(--text-muted);\n  font-size: var(--fs-sm);\n}\n\n/* ============================== Tables: mobile density ============================== */\n@media (max-width: 576px) {\n  .ant-table-tbody > tr > td,\n  .ant-table-thead > tr > th {\n    padding: 10px 12px !important;\n    font-size: var(--fs-xs) !important;\n  }\n}\n\n/* ============================== Badges / Tags ============================== */\n.ant-tag {\n  border-radius: var(--r-full);\n  font-weight: var(--fw-medium);\n  border: none;\n  padding: 2px 12px;\n}\n.ant-badge-count {\n  box-shadow: 0 0 0 2px var(--bg-surface);\n  font-weight: var(--fw-semibold);\n}\n\n/* ============================== Graphics: file/version rows ============================== */\n.gfx-file-row.ant-list-item {\n  border-radius: var(--r-lg);\n  transition: background var(--dur-base) var(--ease-out);\n  padding: 12px 10px !important;\n}\n.gfx-file-row.ant-list-item:hover {\n  background: var(--bg-subtle, #F8FAFC);\n}\n.gfx-file-name {\n  font-weight: var(--fw-semibold);\n  color: var(--text-primary, #0F172A);\n}\n.gfx-file-meta {\n  font-size: 12px;\n  color: var(--text-muted, #94A3B8);\n  margin-top: 2px;\n}\n.gfx-file-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n.gfx-file-view-btn,\n.gfx-file-download-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12.5px;\n  font-weight: 600;\n  padding: 6px 14px;\n  border-radius: var(--r-full);\n  white-space: nowrap;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n.gfx-file-view-btn {\n  color: #0F9E9B;\n  border: 1px solid #9FE3E1;\n  background: #ffffff;\n}\n.gfx-file-view-btn:hover {\n  background: #0F9E9B;\n  color: #ffffff;\n}\n.gfx-file-download-btn {\n  color: var(--brand-500, #3B6B94);\n  border: 1px solid var(--brand-200, #A8C5DA);\n  background: #ffffff;\n}\n.gfx-file-download-btn:hover {\n  background: var(--brand-500, #3B6B94);\n  color: #ffffff;\n}\n.gfx-file-icon-btn.ant-btn {\n  width: 32px !important;\n  height: 32px !important;\n  min-width: 32px !important;\n  padding: 0 !important;\n  border-radius: var(--r-full) !important;\n  display: inline-flex !important;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--border, #E7E9F2) !important;\n  color: var(--text-secondary, #475569) !important;\n  background: #ffffff !important;\n}\n.gfx-file-icon-btn.ant-btn:hover {\n  border-color: var(--brand-300, #7CA7C2) !important;\n  color: var(--brand-500, #3B6B94) !important;\n}\n.gfx-file-icon-btn--danger.ant-btn:hover {\n  border-color: #ffccc7 !important;\n  background: #fff1f0 !important;\n  color: #cf1322 !important;\n}\n.gfx-note-editor {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 6px;\n}\n.gfx-note-editor .ant-input {\n  border-radius: var(--r-md, 8px);\n}\n\n/* ==============================================================\n   Graphics Request Detail -- ported from graphics-Imergey's modern\n   hero-header layout, so Brand/Admin's detail page reads the same\n   as the Graphics Team member's own view of the same request.\n   ============================================================== */\n.gfx-req-hero {\n  border-radius: var(--r-xl, 20px);\n  padding: 22px 26px;\n  margin-bottom: 20px;\n  background: var(--brand-gradient);\n  box-shadow: var(--shadow-brand);\n}\n.gfx-req-hero-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n.gfx-req-hero-eyebrow {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba(255,255,255,0.65);\n  margin-bottom: 4px;\n}\n.gfx-req-hero-title {\n  margin: 0;\n  color: #ffffff;\n  font-size: 21px;\n  font-weight: 700;\n  letter-spacing: -0.2px;\n}\n.gfx-req-hero-actions {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n.gfx-hero-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  height: 34px;\n  padding: 0 16px;\n  border-radius: 9999px;\n  background: rgba(255, 255, 255, 0.10);\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  color: #ffffff;\n  font-size: 12.5px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n.gfx-hero-pill--status {\n  background: rgba(108, 229, 232, 0.14);\n  border-color: rgba(108, 229, 232, 0.38);\n  color: #A9F0F2;\n}\n.gfx-hero-pill .gfx-priority-dot { width: 8px; height: 8px; }\n.gfx-hero-action-btn.ant-btn {\n  height: 34px !important;\n  border-radius: 9999px !important;\n  border: 1px solid rgba(255, 255, 255, 0.25) !important;\n  background: rgba(255, 255, 255, 0.10) !important;\n  color: #ffffff !important;\n  padding: 0 16px !important;\n  font-weight: 600 !important;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n.gfx-hero-action-btn.ant-btn:hover {\n  background: rgba(255, 255, 255, 0.18) !important;\n  color: #ffffff !important;\n  border-color: rgba(255, 255, 255, 0.4) !important;\n}\n.gfx-hero-action-btn.gfx-hero-action-btn--danger.ant-btn {\n  background: rgba(245, 34, 45, 0.16) !important;\n  border-color: rgba(245, 34, 45, 0.35) !important;\n  color: #FFD8D6 !important;\n}\n.gfx-hero-action-btn.gfx-hero-action-btn--danger.ant-btn:hover {\n  background: rgba(245, 34, 45, 0.28) !important;\n}\n\n/* Same pill shape + icon/text alignment as .gfx-hero-action-btn above, but\n   for a plain white/light background (the blog-write version editor drawer)\n   — .gfx-hero-action-btn's own colors (translucent white bg, white text)\n   are only visible on its dark hero-banner background and would be\n   invisible-on-white here, so this keeps antd's own primary/danger\n   coloring and only borrows the shape/alignment fix. */\n.gfx-drawer-action-btn.ant-btn {\n  height: 34px !important;\n  border-radius: 9999px !important;\n  padding: 0 16px !important;\n  font-weight: 600 !important;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  /* Space between separate buttons in the drawer relies on antd's own\n     Space `gap` (flex column-gap on an inline-flex container) — that\n     doesn't render reliably everywhere, so add an explicit fallback\n     margin directly on the button too. The trailing margin on the last\n     button is harmless (just a bit of empty space before the drawer's\n     own edge). */\n  margin-right: 12px;\n}\n\n.gfx-priority-dot { border-radius: 50%; display: inline-block; }\n.gfx-priority-dot.priority-urgent { background: #F5222D; }\n.gfx-priority-dot.priority-high   { background: #FA8C16; }\n.gfx-priority-dot.priority-medium { background: #3B6B94; }\n.gfx-priority-dot.priority-low    { background: #94A3B8; }\n\n/* Meta tiles */\n.gfx-meta-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 14px;\n}\n.gfx-meta-tile {\n  background: var(--bg-subtle, #F8FAFC);\n  border: 1px solid var(--border, #E7E9F2);\n  border-radius: 12px;\n  padding: 14px 16px;\n  min-width: 0;\n}\n.gfx-meta-label {\n  font-size: 10.5px;\n  font-weight: 700;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: var(--text-muted, #94A3B8);\n  margin-bottom: 5px;\n}\n.gfx-meta-value {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary, #0F172A);\n  overflow-wrap: break-word;\n}\n.gfx-meta-tile--alert { background: #FEF2F2; border-color: #FECACA; }\n.gfx-meta-tile--alert .gfx-meta-value { color: #B91C1C; }\n\n/* Brief panels */\n.gfx-brief-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 16px;\n}\n.gfx-brief-panel {\n  background: #ffffff;\n  border: 1px solid var(--border, #E7E9F2);\n  border-left: 3px solid var(--brand-500, #3B6B94);\n  border-radius: 10px;\n  padding: 13px 16px;\n}\n.gfx-brief-label {\n  font-size: 10.5px;\n  font-weight: 700;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: var(--brand-500, #3B6B94);\n  margin-bottom: 6px;\n}\n.gfx-brief-text {\n  font-size: 13.5px;\n  color: var(--text-secondary, #475569);\n  line-height: 1.65;\n  margin: 0;\n  white-space: pre-wrap;\n}\n/* THE actual cause of the \"still not fixed\" line-spacing bug — found it.\n   white-space: pre-wrap above was written for this class's ORIGINAL use\n   (rendering a plain-text field, where it's needed to turn the user's\n   typed line breaks into visible ones, since a plain string has no <p>/\n   <br> tags of its own to do that). It's an INHERITED property, so once\n   this same class started also being used to dangerouslySetInnerHTML real\n   rich HTML (the outline/header/subheader fields), pre-wrap started\n   applying to that markup too — and draftjs-to-html's own output has\n   literal newline characters between block tags (for readability), which\n   pre-wrap then renders as REAL, VISIBLE extra line breaks, stacking on\n   top of each <p>'s own margin. That's what produced gaps of inconsistent,\n   oversized height between lines that no amount of margin tuning alone\n   could fix (previous attempt only touched margin, hence \"still not\n   fixed\"). Fixed by giving the rich-HTML case its own modifier class\n   (.gfx-brief-text-rich, added in JSX alongside .gfx-brief-text) that\n   turns white-space back to normal — collapsing those stray newlines the\n   way HTML always does by default — while leaving plain .gfx-brief-text\n   alone so the legacy flat-string fields (which are NOT HTML, must never\n   get dangerouslySetInnerHTML) keep their pre-wrap behavior intact. */\n.gfx-brief-text.gfx-brief-text-rich {\n  white-space: normal;\n}\n/* Round 2 fix — forcing every <p> to a flat \"margin: 0 0 8px\" (previous\n   attempt) was itself wrong, not just the pre-wrap issue above: it made\n   every paragraph gap the SAME 8px regardless of how many blank lines the\n   writer actually typed in the editor. draftjs-to-html emits one <p> per\n   editor line, and a blank line the writer typed (pressed Enter twice)\n   comes out as its own empty <p>&nbsp;</p> block — so 1 blank line should\n   read as 1 blank-line's worth of gap, 2 blank lines as 2, etc., exactly\n   like it looked while writing. Flattening every <p> margin to 8px erased\n   that distinction (any run of blank lines collapsed to the same gap as a\n   single line break) — that's the \"format is not same as what I typed\"\n   complaint. Fix: margin 0 on every <p> so it's purely line-height driven,\n   the same way the compose editor itself renders lines — an empty <p> then\n   naturally reproduces one blank editor line's height, and N blank lines\n   in a row reproduce N of them, matching the source 1:1. */\n.gfx-brief-text-rich p {\n  margin: 0;\n}\n/* Round 3 fix — the margin:0 approach above was the right idea but still\n   didn't work, because draftjs-to-html doesn't serialize a real blank line\n   as \"<p>&nbsp;</p>\" (what I assumed and tested against) — it serializes it\n   as a completely bare \"<p></p>\" (confirmed by the comment on\n   serializeEditorHtml in NormalEditor.js, which deliberately leaves it\n   untouched for this exact reason). A block element with truly NO content —\n   not even a space — gets NO line box in every browser, so it renders at\n   zero height regardless of line-height/margin. That's why blank lines kept\n   disappearing even after the spacing model was fixed. Giving empty <p>s\n   generated content (a non-breaking space) forces a real line box the same\n   height as any other line, so a blank editor line now actually reproduces\n   as one blank line here, and N in a row as N. */\n.gfx-brief-text-rich p:empty::before {\n  content: \"\\00a0\";\n}\n.gfx-brief-text-rich ul,\n.gfx-brief-text-rich ol {\n  margin: 0;\n  padding-left: 20px;\n}\n.gfx-brief-text-rich li {\n  margin-bottom: 2px;\n}\n/* linkifyHtml (BlogDescriptionModal.js) wraps bare URLs typed into an\n   outline field (the editor's own toolbar has no link button) in a real\n   <a> at display time — styled so it actually reads as a clickable link\n   instead of the same flat body-text color everything else here uses. */\n.gfx-brief-text-rich a {\n  color: var(--brand-500, #3B6B94);\n  text-decoration: underline;\n  word-break: break-all;\n}\n\n/* Matches BlogWriteService.getVersionHtml's docx alignment-preservation\n   transform (backend-Imergey) — paragraphs tagged with these classes carry\n   real alignment from the source .docx (mammoth otherwise drops it by\n   default). An image sitting alone in its own aligned paragraph is centered\n   for free here too, since it just inherits text-align from its <p>. */\n.gfx-brief-text-rich .align-left { text-align: left; }\n.gfx-brief-text-rich .align-center { text-align: center; }\n.gfx-brief-text-rich .align-right { text-align: right; }\n.gfx-brief-text-rich .align-justify { text-align: justify; }\n\n/* Outline \"Body\" block (headers/sub-headers) — these classes existed in the\n   JSX (BlogWriteRequestDetail.js) but had NO CSS defined for them anywhere,\n   so header/subheader titles rendered as plain unstyled text indistinguishable\n   from body copy, and separate blocks (a header's own content, then its\n   subheaders) sat flush against each other with zero gap — since the\n   margin:0 fix above makes each .gfx-brief-text-rich block internally\n   line-height-only, there was nothing left to separate one block from the\n   next. Titles get real heading weight/size; each header/subheader gets a\n   top margin so distinct blocks read as visually separate sections, the\n   same way they're visually separate while writing them in the outline\n   builder. */\n.blog-desc-outline-header {\n  margin-top: 16px;\n}\n.blog-desc-outline-header:first-child {\n  margin-top: 0;\n}\n.blog-desc-outline-header-title {\n  font-size: 14.5px;\n  font-weight: 700;\n  color: var(--text-primary, #0F172A);\n  margin-bottom: 4px;\n}\n.blog-desc-outline-subheader {\n  margin-top: 10px;\n  padding-left: 14px;\n  border-left: 2px solid var(--border, #E7E9F2);\n}\n.blog-desc-outline-subheader-title {\n  font-size: 13.5px;\n  font-weight: 600;\n  color: var(--text-primary, #0F172A);\n  margin-bottom: 4px;\n}\n\n/* Reference file chips */\n.gfx-ref-files { margin-top: 16px; }\n.gfx-ref-chips { display: flex; flex-wrap: wrap; gap: 8px; }\n.gfx-ref-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  max-width: 320px;\n  padding: 8px 14px;\n  border-radius: 9999px;\n  background: var(--brand-50, #EAF1F6);\n  border: 1px solid var(--brand-100, #D2E2EC);\n  color: var(--brand-700, #1D3C56);\n  font-size: 12.5px;\n  font-weight: 600;\n}\n.gfx-ref-chip:hover {\n  background: var(--brand-100, #D2E2EC);\n  color: var(--brand-900, #071E31);\n}\n.gfx-ref-chip-name { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.gfx-ref-chip-dl { color: var(--brand-500, #3B6B94); flex-shrink: 0; }\n\n/* Version cards (Files & Versions tab) */\n.gfx-version-list { display: flex; flex-direction: column; gap: 10px; margin-top: 18px; }\n.gfx-version-item {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 14px;\n  background: var(--bg-subtle, #F8FAFC);\n  border: 1px solid var(--border, #E7E9F2);\n  border-radius: 12px;\n  padding: 13px 18px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n.gfx-version-item:hover {\n  border-color: var(--brand-200, #A8C5DA);\n  box-shadow: 0 3px 10px rgba(15, 23, 42, 0.06);\n}\n.gfx-version-badge {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  background: var(--brand-gradient);\n  color: #ffffff;\n  font-size: 13px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.gfx-version-thumb {\n  cursor: pointer;\n  position: relative;\n  /* No overflow:hidden here — the v# tag below is intentionally pinned to\n     the corner and would get clipped by it. The image itself is rounded\n     via its own border-radius instead. */\n}\n.gfx-version-thumb-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 12px;\n  display: block;\n}\n.gfx-version-thumb-tag {\n  position: absolute;\n  bottom: -4px;\n  right: -4px;\n  min-width: 18px;\n  height: 16px;\n  background: rgba(15, 23, 42, 0.85);\n  border: 1.5px solid #fff;\n  color: #fff;\n  font-size: 9px;\n  font-weight: 700;\n  line-height: 1;\n  padding: 0 4px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.gfx-preview-image {\n  max-width: 100%;\n  max-height: 70vh;\n  display: block;\n  margin: 0 auto;\n  border-radius: 8px;\n}\n.gfx-preview-frame {\n  width: 100%;\n  height: 70vh;\n  border: none;\n  border-radius: 8px;\n}\n.gfx-preview-unsupported {\n  text-align: center;\n  padding: 40px 0;\n  color: var(--text-secondary, #64748B);\n}\n.gfx-version-info { flex: 1; min-width: 0; }\n.gfx-version-name { font-size: 14px; font-weight: 600; color: var(--text-primary, #0F172A); }\n.gfx-version-meta { font-size: 12px; color: var(--text-muted, #94A3B8); margin-top: 2px; }\n.gfx-version-actions { display: flex; align-items: center; gap: 8px; flex-shrink: 0; }\n.gfx-version-icon-btn.ant-btn {\n  width: 32px !important;\n  height: 32px !important;\n  min-width: 32px !important;\n  padding: 0 !important;\n  border-radius: 9999px !important;\n  display: inline-flex !important;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--border, #E7E9F2) !important;\n  color: var(--text-secondary, #475569) !important;\n  background: #ffffff !important;\n}\n.gfx-version-icon-btn.ant-btn:hover {\n  border-color: var(--brand-300, #7CA7C2) !important;\n  color: var(--brand-500, #3B6B94) !important;\n}\n.gfx-version-icon-btn--danger.ant-btn:hover {\n  border-color: #ffccc7 !important;\n  background: #fff1f0 !important;\n  color: #cf1322 !important;\n}\n.gfx-version-note-editor { display: flex; align-items: flex-start; gap: 8px; margin-top: 6px; width: 100%; }\n.gfx-version-note-editor .ant-input { border-radius: 8px; }\n.gfx-version-delete-pending { margin-top: 4px; font-size: 12px; font-weight: 600; color: #B45309; }\n.gfx-version-delete-rejected { margin-top: 4px; font-size: 12px; color: #991B1B; }\n/* The filename doubles as the \"view\" action -- hover reveals it's clickable\n   instead of needing a separate \"View\" button next to Download. */\n.gfx-version-name-row { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }\n.gfx-version-name--link { text-decoration: none; cursor: pointer; transition: color 0.15s ease; }\n.gfx-version-name--link:hover { color: var(--brand-500, #3B6B94); text-decoration: underline; }\n.gfx-version-inline-dl {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  border-radius: 9999px;\n  color: var(--brand-500, #3B6B94);\n  background: var(--brand-50, #EAF1F6);\n  flex-shrink: 0;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n.gfx-version-inline-dl:hover { background: var(--brand-500, #3B6B94); color: #ffffff; }\n\n/* Delivery-date extension banner (pending decision) */\n.gfx-ext-banner {\n  margin-top: 16px;\n  padding: 14px 16px;\n  background: #FFFBEA;\n  border: 1px solid #FDE68A;\n  border-radius: 12px;\n}\n.gfx-ext-banner-text { font-size: 13.5px; color: #78350F; line-height: 1.6; }\n.gfx-ext-banner-reason { margin-top: 4px; font-style: italic; color: #92651A; }\n.gfx-ext-banner-actions { display: flex; gap: 8px; margin-top: 10px; flex-wrap: wrap; }\n.gfx-ext-btn.ant-btn {\n  height: 32px !important;\n  padding: 0 16px !important;\n  border-radius: 9999px !important;\n  font-weight: 600 !important;\n  font-size: 12.5px !important;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n.gfx-ext-btn--approve.ant-btn {\n  background: var(--brand-gradient) !important;\n  border: none !important;\n  color: #ffffff !important;\n}\n.gfx-ext-btn--approve.ant-btn:hover { opacity: 0.9; color: #ffffff !important; }\n.gfx-ext-btn--reject.ant-btn {\n  background: #ffffff !important;\n  border: 1px solid #FCA5A5 !important;\n  color: #B91C1C !important;\n}\n.gfx-ext-btn--reject.ant-btn:hover { background: #FEF2F2 !important; }\n.gfx-ext-btn--reassign.ant-btn {\n  background: #ffffff !important;\n  border: 1px solid var(--border, #E7E9F2) !important;\n  color: var(--text-secondary, #475569) !important;\n}\n.gfx-ext-btn--reassign.ant-btn:hover {\n  border-color: var(--brand-300, #7CA7C2) !important;\n  color: var(--brand-500, #3B6B94) !important;\n}\n\n/* Tabs (pill style) */\n.ant-tabs.gfx-tabs .ant-tabs-nav {\n  background: #ffffff;\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 14px;\n  padding: 6px 8px;\n  margin-bottom: 20px !important;\n}\n.ant-tabs.gfx-tabs .ant-tabs-nav::before { border-bottom: none !important; }\n.ant-tabs.gfx-tabs .ant-tabs-ink-bar { display: none !important; }\n.ant-tabs.gfx-tabs .ant-tabs-tab {\n  padding: 9px 18px !important;\n  border-radius: 9px !important;\n  margin: 0 2px !important;\n  background: transparent !important;\n  transition: background 0.16s ease !important;\n}\n.ant-tabs.gfx-tabs .ant-tabs-tab:hover { background: rgba(59,107,148,0.07) !important; }\n.ant-tabs.gfx-tabs .ant-tabs-tab .ant-tabs-tab-btn { font-size: 13.5px; font-weight: 500; color: #5a7080; }\n.ant-tabs.gfx-tabs .ant-tabs-tab.ant-tabs-tab-active {\n  background: var(--brand-gradient) !important;\n  box-shadow: 0 3px 10px rgba(59,107,148,0.30);\n}\n.ant-tabs.gfx-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: #ffffff !important;\n  font-weight: 700;\n  text-shadow: none;\n}\n\n/* Discussion: composer + chat bubbles */\n.gfx-comment-composer { display: flex; flex-direction: column; align-items: flex-end; gap: 10px; margin-bottom: 22px; }\n.gfx-comment-composer .ant-input {\n  border-radius: 12px !important;\n  border-color: var(--border, #E7E9F2) !important;\n  background: var(--bg-subtle, #F8FAFC) !important;\n  padding: 12px 14px !important;\n  font-size: 13.5px !important;\n}\n.gfx-comment-composer .ant-input:focus {\n  border-color: var(--brand-500, #3B6B94) !important;\n  box-shadow: 0 0 0 3px rgba(59, 107, 148, 0.12) !important;\n  background: #ffffff !important;\n}\n.gfx-comment-post-btn.ant-btn {\n  border-radius: 9999px !important;\n  height: 36px !important;\n  padding: 0 20px !important;\n  font-weight: 600 !important;\n  background: var(--brand-gradient) !important;\n  border: none !important;\n  color: #fff !important;\n  box-shadow: 0 3px 10px rgba(59, 107, 148, 0.28) !important;\n}\n.gfx-comment-post-btn.ant-btn:hover,\n.gfx-comment-post-btn.ant-btn:focus {\n  color: #fff !important;\n}\n.gfx-comment-list { display: flex; flex-direction: column; gap: 14px; }\n.gfx-comment { display: flex; align-items: flex-start; gap: 12px; }\n.gfx-comment-avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: var(--brand-gradient);\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.gfx-comment-bubble {\n  flex: 1;\n  min-width: 0;\n  background: var(--bg-subtle, #F8FAFC);\n  border: 1px solid var(--border, #E7E9F2);\n  border-radius: 4px 14px 14px 14px;\n  padding: 11px 15px;\n}\n.gfx-comment-head { display: flex; align-items: baseline; justify-content: space-between; gap: 10px; margin-bottom: 4px; }\n.gfx-comment-author { font-size: 13px; font-weight: 700; color: var(--text-primary, #0F172A); }\n.gfx-comment-time { font-size: 11px; color: var(--text-muted, #94A3B8); white-space: nowrap; }\n.gfx-comment-text { font-size: 13.5px; color: var(--text-secondary, #475569); line-height: 1.6; margin: 0; white-space: pre-wrap; overflow-wrap: break-word; }\n\n/* Audit trail */\n.gfx-audit { padding-top: 4px; }\n.gfx-audit-action { font-weight: 700; color: var(--text-primary, #0F172A); text-transform: capitalize; }\n.gfx-audit-actor { font-weight: 600; color: var(--brand-500, #3B6B94); }\n.gfx-audit-time { font-size: 12px; color: var(--text-muted, #94A3B8); margin-top: 2px; }\n.gfx-audit-comment {\n  margin-top: 6px;\n  font-size: 13px;\n  color: var(--text-secondary, #475569);\n  background: var(--bg-subtle, #F8FAFC);\n  border: 1px solid var(--border, #E7E9F2);\n  border-radius: 8px;\n  padding: 8px 12px;\n  display: inline-block;\n}\n\n@media (max-width: 992px) {\n  .gfx-meta-grid { grid-template-columns: repeat(2, 1fr); }\n}\n@media (max-width: 560px) {\n  .gfx-meta-grid { grid-template-columns: 1fr; }\n}\n\n/* Blog Description modal — document-styled outline builder. Near-fullscreen,\n   generously padded \"page\" card so drafting the outline feels like working\n   on a document rather than filling a cramped form (direct user feedback on\n   the old flat TextArea + per-section image-upload-button layout). */\n.blog-desc-modal .ant-modal-content { border-radius: 12px; overflow: hidden; }\n/* Wins over the global unscoped \".ant-modal-header { padding: 20px\n   !important; }\" rule in main.css — only !important can override another\n   !important, regardless of selector specificity. */\n.blog-desc-modal .ant-modal-header { padding: 22px 24px 18px !important; }\n.blog-desc-toolbar {\n  position: sticky;\n  top: 0;\n  z-index: 5;\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  padding: 8px 24px;\n  background: #fff;\n  border-bottom: 1px solid var(--border, #E7E9F2);\n  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.05);\n}\n.blog-desc-toolbar-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text-secondary, #475569);\n  cursor: pointer;\n  font-size: 16px;\n  transition: background 0.12s ease, color 0.12s ease;\n}\n.blog-desc-toolbar-btn:hover { background: var(--bg-subtle, #F1F5F9); color: var(--text-primary, #0F172A); }\n.blog-desc-toolbar-btn.active { background: var(--brand-turquoise-tint, #E0F7F5); color: var(--brand-steel-blue, #1F4E79); }\n.blog-desc-toolbar-divider {\n  width: 1px;\n  height: 22px;\n  margin: 0 8px;\n  background: var(--border, #E7E9F2);\n}\n.blog-desc-toolbar-style-select {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  min-width: 116px;\n  height: 34px;\n  padding: 0;\n  border-radius: 8px;\n  transition: background 0.12s ease;\n}\n.blog-desc-toolbar-style-select:hover { background: var(--bg-subtle, #F1F5F9); }\n.blog-desc-toolbar-style-select select {\n  width: 100%;\n  height: 100%;\n  border: 0;\n  background: transparent;\n  color: var(--text-primary, #0F172A);\n  font-size: 14px;\n  font-weight: 700;\n  appearance: none;\n  outline: none;\n  padding: 0 26px 0 12px;\n  cursor: pointer;\n}\n.blog-desc-toolbar-style-caret {\n  position: absolute;\n  right: 10px;\n  color: var(--text-muted, #94A3B8);\n  pointer-events: none;\n  font-size: 10px;\n}\n.blog-desc-page {\n  padding: 56px 64px 64px;\n  max-width: 820px;\n  margin: 0 auto;\n}\n.blog-desc-page-eyebrow {\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--text-muted, #94A3B8);\n  margin-bottom: 8px;\n}\n.blog-desc-page-title {\n  font-family: Georgia, \"Times New Roman\", serif;\n  font-size: 32px;\n  line-height: 1.3;\n  font-weight: 700;\n  color: var(--text-primary, #0F172A);\n  margin: 0 0 20px;\n}\n.blog-desc-page-divider { margin: 32px 0; border-color: var(--border, #E7E9F2); }\n.blog-desc-section { margin-bottom: 36px; }\n.blog-desc-section-label {\n  font-family: Georgia, \"Times New Roman\", serif;\n  font-size: 17px;\n  font-weight: 700;\n  color: var(--text-primary, #0F172A);\n  margin-bottom: 14px;\n}\n.blog-desc-header-block {\n  padding: 22px 24px 24px;\n  margin-bottom: 20px;\n  background: #fff;\n  border: 1px solid var(--border, #E7E9F2);\n  border-radius: 12px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  transition: border-color 0.12s ease, box-shadow 0.12s ease;\n}\n.blog-desc-header-block:focus-within {\n  border-color: var(--brand-turquoise, #14B8A6);\n  box-shadow: 0 0 0 3px var(--brand-turquoise-tint, #E0F7F5);\n}\n.blog-desc-subheader-block {\n  padding: 16px 20px 18px;\n  margin: 16px 0 0 24px;\n  background: var(--bg-subtle, #F8FAFC);\n  border: 1px solid var(--border, #E7E9F2);\n  border-left: 3px solid var(--brand-turquoise, #14B8A6);\n  border-radius: 8px;\n  transition: border-color 0.12s ease, box-shadow 0.12s ease;\n}\n.blog-desc-subheader-block:focus-within {\n  box-shadow: 0 0 0 3px var(--brand-turquoise-tint, #E0F7F5);\n}\n.blog-desc-header-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n.blog-desc-header-title-input {\n  font-size: 17px;\n  font-weight: 700;\n  font-family: Georgia, \"Times New Roman\", serif;\n  padding-left: 0;\n}\n.blog-desc-header-title-input.ant-input::placeholder { color: var(--text-muted, #94A3B8); font-weight: 600; }\n.blog-desc-subheader-title-input {\n  font-size: 14px;\n  font-weight: 600;\n  padding-left: 0;\n}\n.blog-desc-preview-img {\n  max-width: 100%;\n  border-radius: 8px;\n  margin-top: 8px;\n}\n.blog-desc-export-actions { display: flex; gap: 12px; margin-bottom: 20px; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
